import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from '@guildeducationinc/recess';
import { PaymentRequestStatusTag } from '@src/components/PaymentRequestStatusTag';
import { ProgramStatusTag } from '@src/components/ProgramStatusTag';
import { WorkflowType } from '@src/types';
import { useLocale } from 'pe-core-frontend';
import { useTimeAgo } from 'react-time-ago';
export const ApprovalStatusTag = ({ approval, pending }) => {
    const { t, intl } = useLocale();
    const expirationDate = approval.expirationDate ? new Date(approval.expirationDate) : null;
    const tzDate = expirationDate || 0;
    const timeAgo = useTimeAgo({ date: tzDate, locale: intl.locale });
    const isPastDue = expirationDate && expirationDate < new Date();
    const msUntil = expirationDate ? expirationDate.getTime() - Date.now() : 0;
    const daysUntil = msUntil / (1000 * 60 * 60 * 24);
    const isWithinOneWeek = daysUntil > 0 && daysUntil < 7;
    if (pending) {
        if (!approval.expirationDate)
            return '-';
        if (isPastDue) {
            return (_jsx("div", { style: {
                    padding: '0 0.25rem',
                    color: 'black',
                    border: '1px solid var(--background-color-2)',
                    background: 'var(--background-color-2-lighten-50)',
                }, children: _jsx(Typography, { children: t('Past due') }) }));
        }
        const styleBase = {
            padding: '0 0.25rem',
            color: 'black',
            border: isWithinOneWeek ? '1px solid var(--background-color-3)' : '1px solid transparent',
            background: isWithinOneWeek ? 'var(--background-color-3-lighten-50)' : 'transparent',
        };
        return (_jsx("div", { className: 'inline-block', style: styleBase, children: _jsx(Typography, { children: t('Due {interval}', { values: { interval: timeAgo.formattedDate } }) }) }));
    }
    return approval.workflowType === WorkflowType.PAYMENT_REQUEST_APPROVAL ||
        approval.workflowType === WorkflowType.PREIMBURSEMENT_APPROVAL ||
        approval.workflowType === WorkflowType.BUDGET_APPROVAL ? (_jsx(PaymentRequestStatusTag, { paymentRequest: {
            status: approval.workflowableStatus?.toUpperCase(),
            amountRequested: approval.amountRequested,
            amountToPay: approval.amountToPay,
            amountEarmarked: approval.amountEarmarked,
        } })) : (_jsx(ProgramStatusTag, { status: approval.workflowableStatus?.toUpperCase() }));
};
